/**
 * @author: Radim Buráň <xburan03@stud.fit.vutbr.cz>
 */

import './AuctionDetail.css';
import {useEffect} from "react";
import { useState } from "react";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import BidsTable from "./components/BidsTable";
import PicturePanel from "./components/PicturePanel";
import DescriptionPanel from "./components/DescriptionPanel";
import BidPanel from "./components/BidPanel";
import {getFrom} from "../../data/api";
import {useNavigate, useParams} from "react-router-dom";
import {useAuth} from "../../data/userContext";
import {isAuthenticated} from "../../data/roles";
import {Alert} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";

function AuctionDetail(props) {
    const [isLoaded, setLoaded] = useState(false)
    const [auction, setAuction] = useState([])
    const [bidRows, setBidRows] = useState([])
    const [registeredUser, setRegisteredUser] = useState(undefined);
    const navigate = useNavigate()
    const auth = useAuth();
    const {id} = useParams()
    const [openSnack, setOpenSnack] = useState(false);
    const [msgInfo, setMsgInfo] = useState("");

    //Load auction
    useEffect(()=>{
        getFrom('/auctions/' + id)
        .then((res)=> {
            if (res.status === 200) {
                setAuction(res.data);
                setLoaded(true);
            }
        }).catch((e)=>{
            console.error(e);
            navigate('/');
        })
    },[])

    //load bids & registeredUser
    useEffect(()=> {
        if (auction.id === undefined) {
            return;
        }
        updateBids();
        updateRegisteredUser();
    },[auction])

    function updateRegisteredUser() {
        if (!isAuthenticated(auth.user)) {  //user is not logged in, so he def doesn't have reg user obj
            return;
        }

        getFrom('/registeredUsers?userID=' + auth.user.id + '&auctionID=' + auction.id)
            .then((res)=> {
                if (res.status === 200) {
                    if (res.data[0]) {
                        setRegisteredUser(res.data[0]);
                    }
                }
            }).catch((e)=>{
                console.error(e);
        })
    }

    function updateBids() {
        getFrom('/bids?orderPrice=desc&auctionID=' + auction.id)
            .then((res)=> {
                if (res.status === 200) {   //bids loaded
                    updateBidsRows(res.data);
                }
            }).catch((e)=>{
            console.error(e);
        })
    }

    function updateBidsRows(bids) {
        const result = [];
        for (let j = 0; j < bids.length; ++j) {
            let bid = bids[j];
            result.push({
                id: bid.id,
                price: bid.price,
                date: new Date(bid.createdAt).toLocaleString('cs-CZ'),
                user: bid.registeredUser.user.name
            });
        }
        setBidRows(result);
    }

    function registeredToAuction(regUser) {
        updateRegisteredUser();
    }

    function bidAdded(newBid) {
        updateBids();
    }

    function getTitleContent() {
        if (isLoaded) {
            return auction.category.title + " - " + auction.title;
        }
        else {
            return " ";
        }
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    return (
        <div className="auction-detail">

            <Snackbar
                open={openSnack}
                autoHideDuration={5000}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity={msgInfo.severity} sx={{ width: '100%' }}>
                    {msgInfo.msg}
                </Alert>
            </Snackbar>

            <Typography
                component="h3"
                variant="h3"
                align="left"
                color="text.primary">
                    {getTitleContent()}
            </Typography>

            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                bgcolor: 'background.default',
            }}>

                <Box sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: 1,
                }}>
                    <PicturePanel auction={auction} isLoaded={isLoaded}/>

                    <BidPanel regUser={registeredUser} auction={auction} isLoaded={isLoaded}
                              regToAuction={registeredToAuction}
                              bidAdded={bidAdded}
                              setMsgInfo={setMsgInfo}
                              setOpenSnack={setOpenSnack}/>


                </Box>

                <DescriptionPanel auction={auction} isLoaded={isLoaded}/>

                <BidsTable auction={auction} bidRows={bidRows} isLoaded={isLoaded}/>

            </Box>

        </div>
    );
}

export default AuctionDetail;
